module.exports = __webpack_public_path__ + "static/media/icofont.00e93fdf.svg";